<section class="main-container" [ngClass]="isMobile ? 'container' : 'container-flex mx-5 px-5'">
  <div class="back-btn flex align-center f600 fnt-16 pad-top-30" [ngClass]="{'mar-left-10': isMobile}">
    <a class="flex align-center fnt-14" [routerLink]="['/']">
      <span class="icon-left-arrow mar-top-4"></span>
      <span i18n class="mar-left-8">Back</span>
    </a>
  </div>

  <section class="pad-top-30 category-block">

    <div class="d-flex heading-desktop-container justify-content-center p-2" [ngClass]="{'-mx-6': !isMobile}">
      <pv-svg-icon *ngIf="categoryIcon" [srcUrl]="categoryIcon" styleClass="category-icon"
        class="d-flex align-items-center"></pv-svg-icon>
      <span class="font-bold text-lg text-white ml-2">
        {{selectedCategory?.attributes?.name}}
      </span>
    </div>

    <!-- <ng-template #MobileHeading>
      <h2 class="category-name flex fnt-24 f500 mar-bot-20 mar-left-10 mt-2">
        <img class="img-fluid cat-icon mar-right-15 mar-top-1" [src]="(appConstants?.categories?.[selectedCategory?.attributes?.code] ? appConstants?.categories?.[selectedCategory?.attributes?.code]?.img : selectedCategory?.attributes?.logo_url) ">
        <span class="font-bold text-lg">
          {{selectedCategory?.attributes?.name}}
        </span>
      </h2>
    </ng-template> -->

    <app-tag-based-offers class="d-flex flex-column" [categoryRefresh]="categoryRefresh"
      [categoryCode]="selectedCategory?.attributes?.code" [categoryName]="selectedCategory?.attributes?.name"

      [ngClass]="isMobile ? '-mx-10px': '-mx-5'"></app-tag-based-offers>

    <div class="d-flex align-items-center mt-3" [ngClass]="isMobile ? '-mx-10px mb-5': '-mx-6 pb-5'">
      <hr class="w-100 opacity-100">
      <span i18n class="text-nowrap font-bold mx-1 text-2xl mb-1" [ngClass]="isMobile ? 'text-lg' : ''">All Offers</span>
      <hr class="w-100 opacity-100">
    </div>

    <section class="special-offers container mar-top-25 row px-0 mx-auto" infiniteScroll [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50" (scrolled)="onScroll()" [infiniteScrollDisabled]="preventCallingHandler">
      <app-offers-card class="col-sm-3 offer-card" [offer]="offer" [authenticated_user]="authenticated_user"
        [isMobile]="isMobile" *ngFor="let offer of offers" clickPosition="all-offers" [offerType]="selectedCategory.attributes.code"></app-offers-card>

      <ng-container *ngIf="offerProgress">
        <div class="w-100 d-block" *ngFor="let a of [0,1,2]">
          <app-card-loader [count]="6" rowClass="w-100 m-auto" [perLine]="isMobile ? 2 : 4"></app-card-loader>
        </div>
      </ng-container>
    </section>
  </section>

</section>